import React, { Fragment } from 'react';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import normalVolumeFile from '../assets/audio/notification.mp3'
import highVolumeFile from '../assets/audio/notification-loud.mp3'
import store from '../store/store'

const normalVolumeNotification = new Audio(normalVolumeFile);
const highVolumeNotification = new Audio(highVolumeFile);

const Noti = ({title, msg, url, chatData}) => {

	const handleClick = () => {
		const actualPath = window.location.pathname;
		if(actualPath !== "/inbox"){ 
			window.location.href = `/inbox`;
			localStorage.setItem("chatData", JSON.stringify(chatData));
		} else {
			window.dispatchEvent(new CustomEvent('newChatData', {
				detail: {
					value: chatData
				}
			}));
		}

	}

	return (<Fragment>
		<h4 className="noti-title">{title}</h4>
		<p className="noti-msg">{msg}</p>
		{
			url ? <a href={url} className="btn btn-secondary">Ver</a> : null
		}
		{chatData ? <Button color="secondary" onClick={handleClick}>Ver</Button> : null}
	</Fragment>
	)
} 

class Notification {

	constructor(){
		this.mp3_notification = normalVolumeNotification;
		this.mp3_notification_loud = highVolumeNotification;
		this.selected_mp3;
	}

	// TODO: esta clase no se deberia usar para tocar nada en redux y menos para otra funcionalidad ajena...
	// >.>  -_-  bueee u_u
	closePreloader () { store.dispatch({type: "REMOVE_LOADING"})  }

	pushSoundHandler = (sound, loop) => {

		if(sound === "off") return;

		if (sound === "on") {
			this.selected_mp3 = this.mp3_notification
			this.selected_mp3.preload = true;
		}
		else if (sound === "loud") {
			this.selected_mp3 = this.mp3_notification_loud;
			this.selected_mp3.preload = true;
		}

		// make the sound loop
		if (loop && this.selected_mp3)
			this.selected_mp3.loop = true;

		// esto es para evitar el error de audio can not play file without user interaction
		Promise.resolve(
			this.selected_mp3 && this.selected_mp3.play()
		).catch(err => console.log("No se pudo reproducir el audio de notificación en tu navegador"));
	}

	show = ({title, msg, type, url, sound, autoC, chatData, config= {}}) => {
		const comp = <Noti title={title} msg={msg} url={url} autoClose={autoC} chatData={chatData}/>;

		switch(type){
			case 'success':
				toast.success( comp, {
					onOpen: (o) => this.closePreloader()
				});
				break;

			case 'info':
				toast.info( comp, {
					onOpen: (o) =>  this.closePreloader()
				});
				break;

			case 'error':
				toast.error( comp, {
					onOpen: (o) => this.closePreloader()
				});
				break;

			case 'warning':
				toast.warn( comp, {
					...config,
					onOpen: (o) => this.closePreloader()
				});
				break;

			case 'push':
				toast.info(comp);
				this.pushSoundHandler(sound);
				break;

			case 'sticky-push':
				toast.info(comp, {
					...config,
					onOpen: (o) => {
						this.pushSoundHandler(sound, true);
					},
					onClose: (o) => {
						// si el usuario tiene el sonido en off para una notificacion, selected_mp3 es undefined
						if (this.selected_mp3){
							this.selected_mp3.loop = false;
							this.selected_mp3.pause();
						}
					}
				});
				break;

			default:
				toast.info( comp, {
					onOpen: (o) => this.closePreloader()
				});
				break;
		}
	}
}

export default new Notification();



// WEBPACK FOOTER //
// ./src/handlers/Notification.js